module.exports = __webpack_public_path__ + "img/image 10.bb69e6e5.png";